module.exports = __webpack_public_path__ + "assets/images/ert_sports4.58df837ca4781041cf11fcbbb6002ea5.png";